function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6.47202 7.59619L6.47202 2.54374L14.2726 7.59619L6.47202 12.6486L6.47202 7.59619Z",
  stroke: "currentColor"
});

function SvgIcPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTYuNDcyMDIgNy41OTYxOUw2LjQ3MjAyIDIuNTQzNzRMMTQuMjcyNiA3LjU5NjE5TDYuNDcyMDIgMTIuNjQ4Nkw2LjQ3MjAyIDcuNTk2MTlaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { SvgIcPlay as ReactComponent };